<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M3 3v18h18" />
  <rect x="7" y="11" width="3" height="6" />
  <rect x="13" y="7" width="3" height="10" />
</svg></template>

<script>
export default {}
</script>